import { render, staticRenderFns } from "./JfOver.vue?vue&type=template&id=c7bf869e&scoped=true&"
import script from "./JfOver.vue?vue&type=script&lang=js&"
export * from "./JfOver.vue?vue&type=script&lang=js&"
import style0 from "./JfOver.vue?vue&type=style&index=0&id=c7bf869e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bf869e",
  null
  
)

export default component.exports